import _ from 'underscore';

module.exports = {

  getEventsAttendedByUser({ user, events }) {
    return _.chain(events)
            .pluck('accountUserEventData')
            .flatten()
            .where({ attended: true, userId: user.id })
            .pluck('event')
            .uniq()
            .compact()
            .value();
  },

  getRecruitsAttendedByUser({ user, events }) {
    return _.chain(events)
            .pluck('accountUserEventData')
            .flatten()
            .filter(eventData => eventData.userId === user.id)
            .where({ attended: true })
            .pluck('event')
            .uniq()
            .pluck('accountRecruits')
            .flatten()
            .uniq()
            .compact()
            .sortBy('lastName')
            .value();
  },

  getTop20List(lists, user) {
    if (!_.isArray(lists)) {
      return null;
    }
    return _.findWhere(lists, { category: 'TOP_20', userId: user.id }) || {};
  },

  hasRecruiterRole(staffUserDetails) {
    if (staffUserDetails && _.isArray(staffUserDetails.accounts)) {
      return _.any(staffUserDetails.accounts, (acct) => _.contains(acct.roles, 'Recruiter'));
    } else {
      return false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/util/StaffUtils.js